(() => {
  'use strict';
  if (window.ucwProductQuantityInitialized) return;
  window.ucwProductQuantityInitialized = true;
document.addEventListener('click', function(event) {
  const minus = event.target.closest('[data-uw-card-qty-minus]');
  const plus = event.target.closest('[data-uw-card-qty-plus]');

  if (!minus && !plus) return;
  const button = minus || plus;
  if (button.matches(':disabled')) return;
  event.preventDefault();

  const qtyWrapper = event.target.closest('[data-uw-card-qty]');
  if (!qtyWrapper) return;

  const input = qtyWrapper.querySelector('input[name="quantity"]');
  if (!input) return;

  const min = parseInt(input.getAttribute('min'), 10) || 1;
  const max = input.getAttribute('max') ? parseInt(input.getAttribute('max'), 10) : null;
  const step = parseInt(input.getAttribute('step'), 10) || 1;
  let value = parseInt(input.value, 10) || min;
  value = min + Math.round((value - min) / step) * step;

  if (plus) {
    value += step;
  }

  if (minus) {
    value -= step;
  }

  if (value < min) value = min;
  if (max !== null && value > max) value = max;

  input.value = value;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});
})();
